import React from 'react';
import { observer } from 'mobx-react';
import { useMst } from '../../../internal';
import { Button } from '../../../components/UI/buttons/regular/Button';
import styles from './KreirajOdgovor.module.scss';

export const PitanjeDetalji = observer((): JSX.Element => {
  const { currentPage } = useMst();

  return (
    <div className={styles.PageContainer}>
      <h2 className={styles.Title}>Izmeni pitanje</h2>

      <div className={styles.Form}>
        <div className={styles.Field}>
          <label htmlFor="questionText">Tekst pitanja *</label>
          <input
            id="questionText"
            type="text"
            value={currentPage.questionText}
            onChange={(e) => currentPage.setQuestionText(e.target.value)}
          />
        </div>

        <div className={styles.Field}>
          <label htmlFor="image">Slika uz pitanje</label>
          <input
            id="image"
            type="file"
            accept="image/*"
            onChange={(e) => {
              const file = e.target.files?.[0];
              if (file) currentPage.uploadImage(file);
              e.target.value = '';
            }}
          />
          {currentPage.image && (
            <div className={styles.ImagePreview}>
              <img src={currentPage.imageUrl} alt="Slika pitanja" />
              <Button onClick={() => currentPage.removeImage()}>
                Ukloni sliku
              </Button>
            </div>
          )}
        </div>

        <div className={styles.CheckboxField}>
          <input
            id="isActive"
            type="checkbox"
            checked={currentPage.isActive}
            onChange={(e) => currentPage.setIsActive(e.target.checked)}
          />
          <label htmlFor="isActive">Aktivno</label>
        </div>

        <div className={styles.Actions}>
          <Button
            onClick={() => currentPage.submit()}
            disabled={!currentPage.questionText.trim()}
          >
            Sačuvaj
          </Button>
          <Button onClick={() => currentPage.navigateBack()}>Otkaži</Button>
          <Button onClick={() => currentPage.navigateToOdgovori()}>
            Odgovori
          </Button>
        </div>
      </div>
    </div>
  );
});
